export * from "@shared/components/login/login.component"
export class EmptyComponent { }
